<template>
  <div class="table-page">
    <slot name="top" />
    <slot name="searchInput" />
    <!-- 表格 -->
    <div id="tablearea" class="table-area">
      <el-table
          v-if="isTable"
          ref="table"
          :empty-text="emptyText"
          :height="elTableHeight"
          :max-height="elTableMaxHeight"
          :size="tableSize"
          :data="tableDataList"
          :stripe="stripe"
          :cell-style="cellStyle"
          highlight-current-row
          :show-summary="showSummary"
          :row-key="getRowkey"
          :default-expand-all="expandAll"
          :expand-row-keys="expandRowKeys"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @row-dblclick="rowDbclick"
          @cell-click="cellClick"
          @row-click="rowClick"
          @selection-change="handleSelectionChange"
      >
        <!--  :summary-method="summaryMethod" -->
        <slot name="tableColumn" />
      </el-table>
    </div>
    <!-- 分页 -->
    <div :style="fenyeStyle" class="pagination-container" v-if="isPagination">
      <div>&nbsp;&nbsp;&nbsp;
        <slot name="footerSelect" />
      </div>
      <el-pagination
          :current-page.sync="table.pageNum"
          :pager-count="pagerCount"
          :page-size="table.pageSize"
          :total="table.count"
          :page-sizes="pageSizes"
          :layout="pagelayout"
          background
          class="pagination"
          @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablePage',
  props: {
    // 传入的表格数据
    table: {
      type: Object,
      default: () => ({
        data: [], // 数据
        page: 1, // 当前页数
        limit: 10, // 一页显示数量
        count: 0 // 总数量
      })
    },
    cellStyle:{
      type: Function,
      // default: (param) => { },
    },
    // 斑马纹表格
    stripe: {
      type: Boolean,
      default: false
    },
    // 竖直方向边框
    border: {
      type: Boolean,
      default: true
    },
    // 总计行
    showSummary: {
      type: Boolean,
      default: false
    },
    // 总计方法
    summaryMethod: {
      type: Function,
      // default: (param) => { },
    },
    // 全部展开
    expandAll: {
      type: Boolean,
      default: false
    },
    // 默认展开的行的id
    expandRowKeys: {
      type: Array,
      default: () => []
    },
    // 自动分页
    autoPaging: {
      type: Boolean,
      default: false
    },
    // 分页style
    fenyeStyle: {
      type: Object
    },
    // 分页数设置
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    },
    loading:{
      default:false,
    },
    // 是否表格
    isTable: {
      type: Boolean,
      default: true
    },
    tableData:{
      type:Array,
      default:()=>[],
    },
    heightTable:{
      type:String,
      default:"",
    },
    maxHeight:{
      type:String,
      default:"80vh",
    },
    pagelayout:{
      type:String,
      default:"total,prev,pager,next,jumper"
    },
    pagerCount:{
      type:Number,
      default:7
    },
    isPagination:{
      type:Boolean,
      default:true
    },
    topHeight:{
      type:Number,
      default:-1,
    },
    rowKey:{
      type:String,
      default:''
    },
    /** 为 true 时不固定表格高度，随数据行数撑开（无内部滚动条） */
    autoHeight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      height:270,
      //    emptyText:"正在加载",
    }
  },
  computed: {
    tableDataList(){
      if (this.autoPaging) {
        const { pageSize, pageNum } = this.table
        if (this.tableData && this.tableData.length) {
          return this.tableData.slice((pageNum - 1) * pageSize, pageNum * pageSize)
        }
      }
      return this.tableData
    },
    // 显示的表格数据
    // tableData() {
    //     // if (this.autoPaging) {
    //     //     const { data, limit, page } = this.table
    //     //     if (data && data.length) {
    //     //         return data.slice((page - 1) * limit, page * limit)
    //     //     }
    //     // }
    //     return this.table.data
    // },
    // 返回表格选择项
    selection() {
      if (this.isTable) {
        return this.$refs.table.selection
      }
      return this.$refs.cardTable.selection
    },
    // 根据分辨率控制表格大小
    tableSize() {
      // const screenWidth = window.screen.width
      // if (screenWidth > 1920) {
      //     return 'large'
      // }
      // if (screenWidth <= 1920 && screenWidth > 1680) {
      //     return 'medium'
      // }
      // if (screenWidth <= 1680 && screenWidth >= 1367) {
      //     return 'small'
      // }
      return 'large'
    },
    emptyText(){
      if(this.loading){
        return "正在加载"
      }else{
        return "暂无数据"
      }
    },
    elTableHeight() {
      return this.autoHeight ? undefined : this.height
    },
    elTableMaxHeight() {
      return this.autoHeight ? undefined : this.maxHeight
    }
  },
  mounted() {
    this.clientHeight()
  },

  updated() {
    if (this.autoPaging) {
      this.table.count = this.tableData.length
    }
  },
  methods: {
    clientHeight(){
      //重新渲染表格样式，防止表格样式错乱
      this.$nextTick(()=>{
        if (this.$refs.table) this.$refs.table.doLayout()
      })
      if (this.autoHeight) return
      if(!this.heightTable){
        if(this.topHeight!=-1) this.myUtils.tableHeight(this,this.topHeight)
        else this.myUtils.tableHeight(this)
      }else{
        this.$nextTick(() => {
          this.height=this.heightTable
        })

      }
    },
    // 全选
    toggleAllSelection() {
      if (this.isTable) {
        this.$refs.table.toggleAllSelection()
      } else {
        this.$refs.cardTable.toggleAllSelection()
      }
    },
    handleSelectionChange(val){
      this.$emit("selection-change",val)
    },
    // 换页
    changePage(e) {
      if (this.autoPaging) {

        this.table.page = e
      } else {

        this.$emit('changePage', e)
      }
    },
    // 更换每页显示数量
    changeSize(e) {
      if (!this.autoPaging) {

        this.$emit('changeSize', e)
      } else {

        this.table.page = 1

        this.table.limit = e
      }
    },
    getRowkey(row) {
      if(this.rowKey){
        return row[this.rowKey];
      }
      if(!row.id){
        return
      }
      if(row.indexId){
        return  row.indexId
      }
      return row.id
    },
    cellClick(row, column, cell, event) {
      this.$emit('cell-click', row, column, cell, event)
    },
    rowDbclick(row, column, event) {
      this.$emit('row-dblclick', row, column, event)
    },
    rowClick(row, column, event) {
      this.$emit('row-click', row, column, event)
    }
  }
}
</script>
<style scoped lang="less">
.table-page{
  .pagination-container{
    background:#FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
    // border:1px solid #EBEEF5;
    // border-top:none
  }
  .pagination{
    border:none
  }
}

</style>



